import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from "./Modal";
import { ModalContext, useModalContext } from "./ModalContext";
import { jsx as ___EmotionJSX } from "@emotion/react";
var ModalContextProviderForUseModal = _ref => {
  var {
    children,
    setClose = () => {},
    setIsOpen = () => {},
    setOpen = () => {}
  } = _ref;
  var {
    close,
    isOpen,
    open
  } = useModalContext();
  useEffect(() => {
    setClose(() => close);
  }, [close, setClose]);
  useEffect(() => {
    setIsOpen(isOpen);
  }, [isOpen, setIsOpen]);
  useEffect(() => {
    setOpen(() => open);
  }, [open, setOpen]);
  return ___EmotionJSX(ModalContext.Provider, {
    value: {
      close,
      isOpen,
      open
    }
  }, children);
};
export function useModal(ModalComponent) {
  if (ModalComponent === void 0) {
    ModalComponent = Modal;
  }
  var [close, setClose] = useState(() => () => {});
  var [isOpen, setIsOpen] = useState(false);
  var [open, setOpen] = useState(() => () => {});
  var ModalForUseModal = useCallback(props => ___EmotionJSX(ModalContextProviderForUseModal, {
    setClose: setClose,
    setIsOpen: setIsOpen,
    setOpen: setOpen
  }, ___EmotionJSX(ModalComponent, props)), []);
  ModalForUseModal.Body = Modal.Body;
  ModalForUseModal.Header = Modal.Header;
  ModalForUseModal.PrimaryButton = Modal.PrimaryButton;
  ModalForUseModal.SecondaryButton = Modal.SecondaryButton;
  return {
    Modal: ModalForUseModal,
    ModalContextProvider: ModalContextProviderForUseModal,
    close,
    isOpen,
    open
  };
}